<template>
  <div class="form-group">
    <label v-if="label" class="form-label text-muted">
      {{ label }} <i v-if="required" class="text-danger">*</i>
    </label>
    <div
      v-for="(item, index) in options"
      :key="'option_' + index"
      class="d-flex align-items-center"
      :class="{ 'border-bottom': options.length > index + 1 }"
    >
      <label
        :for="name + '_' + index"
        class="text-paragraph mb-0 flex-fill cursor-pointer py-3"
      >
        {{ item.name || item.title }}
      </label>
      <input
        hidden
        type="radio"
        v-model="model.$model"
        :value="item.id"
        :id="name + '_' + index"
        :name="name"
        @change="onChange($event)"
      />
      <i
        class="fa-solid fa-check fa-xl text-secondary"
        v-if="model.$model == item.id"
      ></i>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    model?: any;
    label?: string;
    options?: any[];
    required?: boolean;
    name: string;
  }>(),
  {
    model: () => ({}),
    label: "",
    options: () => [],
    required: false,
    name: "",
  },
);

const emit = defineEmits<{
  onChange: [value: string];
}>();

const onChange = (event: Event) => {
  emit("onChange", (event.target as HTMLInputElement).value);
};
</script>
